import StyledSvg from 'icons/StyledSvg';
import { IconProps } from 'icons/types';

export const WhatsApp = ({ size, color, x = '0px', y = '0px', scale = 0 }: IconProps) => {
  return (
    <StyledSvg
      xmlns="http://www.w3.org/2000/svg"
      width={size || '40px'}
      height={size || '40px'}
      scale={scale || 0}
      x={x}
      y={y}
      viewBox="0 0 40 40"
      fill={color || 'currentColor'}
    >
      <svg
        width="40"
        height="40"
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.1683 2.32804C13.4311 1.58732 12.5531 1.00001 11.5854 0.600331C10.6178 0.200649 9.57987 -0.00341053 8.53216 4.3116e-05C4.14221 4.3116e-05 0.564322 3.56003 0.564322 7.92802C0.564322 9.32802 0.934171 10.688 1.62563 11.888L0.5 16L4.72111 14.896C5.88693 15.528 7.19749 15.864 8.53216 15.864C12.9221 15.864 16.5 12.304 16.5 7.93602C16.5 5.81603 15.6719 3.82403 14.1683 2.32804ZM8.53216 14.52C7.34221 14.52 6.17638 14.2 5.15528 13.6L4.91407 13.456L2.40553 14.112L3.07286 11.68L2.91206 11.432C2.25079 10.3817 1.89974 9.16744 1.89899 7.92802C1.89899 4.29603 4.87387 1.33604 8.52412 1.33604C10.293 1.33604 11.9573 2.02404 13.2035 3.27203C13.8207 3.88312 14.3098 4.61006 14.6424 5.41069C14.975 6.21132 15.1446 7.06969 15.1412 7.93602C15.1573 11.568 12.1824 14.52 8.53216 14.52ZM12.1663 9.59202C11.9653 9.49602 10.9844 9.01602 10.8075 8.94402C10.6226 8.88002 10.494 8.84802 10.3573 9.04002C10.2206 9.24002 9.84271 9.68802 9.73015 9.81602C9.61759 9.95202 9.49698 9.96802 9.29598 9.86402C9.09497 9.76802 8.45176 9.55202 7.69598 8.88002C7.101 8.35202 6.70703 7.70402 6.58643 7.50402C6.47387 7.30402 6.57035 7.20002 6.67487 7.09602C6.76332 7.00802 6.87588 6.86402 6.97236 6.75203C7.06884 6.64003 7.10905 6.55203 7.17337 6.42403C7.23769 6.28803 7.20553 6.17603 7.15729 6.08003C7.10904 5.98403 6.70703 5.00803 6.54623 4.60803C6.38543 4.22403 6.21658 4.27203 6.09598 4.26403H5.71005C5.57337 4.26403 5.36432 4.31203 5.1794 4.51203C5.00251 4.71203 4.48794 5.19203 4.48794 6.16803C4.48794 7.14402 5.20352 8.08802 5.3 8.21602C5.39648 8.35202 6.70703 10.352 8.701 11.208C9.17538 11.416 9.54523 11.536 9.83467 11.624C10.309 11.776 10.7432 11.752 11.0889 11.704C11.4749 11.648 12.2709 11.224 12.4317 10.76C12.6005 10.296 12.6005 9.90402 12.5442 9.81602C12.4879 9.72802 12.3673 9.68802 12.1663 9.59202Z"
          fill="#757575"
        />
      </svg>
    </StyledSvg>
  );
};
